import * as React from "react";
import type { SVGProps } from "react";
const SvgLockClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 16c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3-3 1.35-3 3m2 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 7v2c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3V7c0-2.76-2.24-5-5-5S7 4.24 7 7m0 4h10c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1m8-4v2H9V7c0-1.65 1.35-3 3-3s3 1.35 3 3"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLockClosed;
